import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

import Footer from "../inc/Footer";
import { path } from "../../../utils";
import Header from "../inc/Header";
import "./ShippingPolicy.scss";
class ShippingPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    let { language } = this.props;
    return (
      <>
        <Header />
        {language === "vi" ? (
          <div className="container shipping">
            <div className="intro">
              <h2>CHÍNH SÁCH & ĐIỀU KHOẢN DỊCH VỤ</h2>
              <p>Áp dụng cho tất cả khách hàng tại Việt Nam</p>
              <p>
                Công ty TNHH Hải Phước - Nhà phân phối chính thức thiết bị phân
                tích cơ thể Anovator A5
              </p>
            </div>
            <h2>3. CHÍNH SÁCH VẬN CHUYỂN</h2>
            <p>
              🚚 <strong>Giao hàng toàn quốc – An tâm từng bước</strong>
              <br />
              Chúng tôi hợp tác với các đơn vị vận chuyển uy tín để đảm bảo
              thiết bị của bạn được giao nhanh chóng, nguyên vẹn và đúng hẹn.
            </p>

            <h4>📦 Thời gian giao hàng:</h4>
            <ul>
              <li>
                Khu vực nội thành TP.HCM và Hà Nội:{" "}
                <strong>1-2 ngày làm việc</strong>
              </li>
              <li>
                Các tỉnh thành khác: <strong>7-10 ngày làm việc</strong>
              </li>
            </ul>

            <h4>💰 Cước phí:</h4>
            <ul>
              <li>
                <strong>Miễn phí giao hàng toàn quốc</strong> cho đơn hàng máy{" "}
                <strong>Anovator A5</strong>
              </li>
              <li>
                <strong>Phụ kiện đi kèm</strong> có thể phát sinh phí tùy theo
                loại sản phẩm và khu vực giao hàng (phí sẽ được hiển thị rõ ràng
                tại bước thanh toán)
              </li>
            </ul>

            <h4>📋 Lưu ý khi nhận hàng:</h4>
            <ul>
              <li>
                Vui lòng <strong>quay video quá trình mở hộp</strong> để đảm bảo
                quyền lợi nếu cần khiếu nại
              </li>
              <li>
                Nếu{" "}
                <strong>
                  sản phẩm bị móp méo, rách vỡ hoặc thiếu phụ kiện
                </strong>{" "}
                - hãy <strong>từ chối nhận hàng</strong> và liên hệ với chúng
                tôi ngay
              </li>
            </ul>
            <div className="contact-info support">
              <h2>THÔNG TIN LIÊN HỆ HỖ TRỢ</h2>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối Anovator chính thức tại
                Việt Nam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Điện thoại:</strong> 0359.951.5131 (Phước)
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Văn Phòng Chính - Top Fitness Center:</strong>
                <br />
                227 - 229 Hà Huy Giáp, Phường Thạnh Lộc, Quận 12
              </p>
            </div>
          </div>
        ) : (
          <div className="container shipping">
            <div className="intro">
              <h2>POLICIES & TERMS OF SERVICE</h2>
              <p>Applicable to all customers in Vietnam</p>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator A5 Body
                Composition Analyzer
              </p>
            </div>
            <h2>3. SHIPPING POLICY</h2>
            <p>🚚 Nationwide delivery - Peace of mind every step of the way</p>
            <p>
              We partner with trusted logistics providers to ensure your device
              is delivered promptly, safely, and on time.
            </p>

            <h3>📦 Delivery Time:</h3>
            <ul>
              <li>Ho Chi Minh City & Hanoi (inner city): 1-2 business days</li>
              <li>Other provinces: 7-10 business days</li>
            </ul>

            <h3>💰 Shipping Fee:</h3>
            <ul>
              <li>Free nationwide shipping for Anovator A5 orders</li>
              <li>
                Accessories may incur a fee depending on type and location
                (clearly shown in cart)
              </li>
            </ul>

            <h3>📋 Important Notes on Delivery:</h3>
            <ul>
              <li>
                Please record a video while unboxing to protect your rights in
                case of claims
              </li>
              <li>
                If the package is dented, torn, broken, or missing accessories -
                please refuse delivery and contact us immediately
              </li>
            </ul>
            <div className="contact-info support">
              <h2>SUPPORT CONTACT INFORMATION</h2>
              <p>
                Hai Phuoc Co., Ltd – Official Distributor of Anovator in Vietnam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Phone:</strong> 0989.499.889
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Head Office – Top Fitness Center:</strong>
                <br />
                227 – 229 Ha Huy Giap Street, Thanh Loc Ward, District 12
              </p>
            </div>
          </div>
        )}

        <Footer />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingPolicy),
);
